import styled from "styled-components";
import { SectionTitle } from "common/text";

type SuggestedClassesSectionProps = {
  "background-url": string;
};

export const Section = styled.div`
  padding: 42px 8%;
  display: flex;
  flex-direction: column;
`;

export const SuggestedClassesSection = styled(Section)`
  background-color: #1070b6;
  background-image: ${(props: SuggestedClassesSectionProps) =>
    props["background-url"] ? `url(${props["background-url"]})` : ""};
  background-repeat: repeat;
`;

export const SuggestedClassesSectionTitle = styled(SectionTitle)`
  color: white;
`;

export const BookClassSection = styled(Section)`
  background-color: #f6f6f6;
`;

export const SectionHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;
